/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsApiKey,
    ControlcenterMelcoModelsApiKeyFromJSON,
    ControlcenterMelcoModelsApiKeyFromJSONTyped,
    ControlcenterMelcoModelsApiKeyToJSON,
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoModelsApiKey
 */
export interface ControlcenterMelcoModelsGenericList1MelcoModelsApiKey {
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsApiKey>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsApiKey
     */
    list: Array<ControlcenterMelcoModelsApiKey>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsApiKey
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsApiKey
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsApiKeyFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoModelsApiKey {
    return ControlcenterMelcoModelsGenericList1MelcoModelsApiKeyFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsApiKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoModelsApiKey {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoModelsApiKeyFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsApiKeyToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoModelsApiKey | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoModelsApiKeyToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


